export interface OriginConstantSettings
{
    click: 'Click';
    deferredAppCall: 'Deferred AppCall';
    external: 'External';
    internal: 'Internal';
    typed: 'Typed';
    voice: 'Voice';
}

export interface AgentAssistOriginConstantSettings extends OriginConstantSettings
{
    agentAssistClick: "AgentAssistClick";
}

export default {
    originConstants: {
        click: 'Click',
        deferredAppCall: 'Deferred AppCall',
        external: 'External',
        internal: 'Internal',
        typed: 'Typed',
        voice: 'Voice',
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/origin-constants.ts